import usePagination from "src/customHooks/usePagination";
import PageHeader from "src/components/pageHeader";
import Pagination from "src/components/pagination";
import PageLoading from "src/components/pageLoading";
import { ActiveSlotsReport } from "../types/slot.entity";
import { useCountActiveSlotsReportsQuery, useGetActiveSlotsReportsQuery } from "../services/active-slots-reports.service";
import ActiveSlotsReportsTable from "../components/active-slots-reports-table";
import { ActiveSlotsReportsTableSkeleton } from "../components/ActiveSlotsReportsTableSkeleton";

const ActiveSlotsReportsPage = () => {
  const { data, numberOfPages, currentPage, next, prev, isSuccess, isError, isLoading, isFetching } =
    usePagination<ActiveSlotsReport & { id: string }>({
      useGetDataQuery: useGetActiveSlotsReportsQuery,
      useCountData: useCountActiveSlotsReportsQuery,
      initQuery: {},
    });

  return (
    <div className="page_container">
      <PageHeader text="Active Slots Reports" />

      {isSuccess ? (
        <>
          {isLoading || isFetching ? (
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
                <thead className="bg-gray-900 text-white text-center">
                  <tr>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">Slot</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">User</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">Lang</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">Status</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">Created</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">When</th>
                    <th className="px-4 py-3 uppercase text-xs tracking-wider">Reported At</th>
                  </tr>
                </thead>
                <tbody>
                  <ActiveSlotsReportsTableSkeleton rows={10} />
                </tbody>
              </table>
            </div>
          ) : data ? (
            <ActiveSlotsReportsTable data={data} />
          ) : null}
          <Pagination numberOfPages={numberOfPages || 1} currentPage={currentPage} prev={prev} next={next} isLoading={isLoading || isFetching} />
        </>
      ) : isError ? (
        <div className="mt-6 p-4 rounded border border-red-200 bg-red-50 text-red-700">
          Something went wrong loading active slots reports. Please try again.
        </div>
      ) : (
        <PageLoading />
      )}
    </div>
  );
};

export default ActiveSlotsReportsPage;
